import HmacMD5 from 'crypto-js/hmac-md5'
import Hex from 'crypto-js/enc-hex'

export const getSecret = (productId, body) => {
  // 使用HMAC-md5 对 request body 签名, 使用的 key 根据 X-Cf-Productid 头部字段而定，获得该摘要的 hex 形式小写字符串
  // 示例：
  // 1.X-Cf-Productid 为 '0'
  // 2.使用的key 为 'abc'
  // 3.请求的 body 为 '{"common":{"token":"21dc5ae0207e237e308812d5ebc7250fbff18cea"}}'
  // 示例得到:
  // X-Cf-Authorization 头部字段为 '09612553307e60896a2cc3365db88384'
  body = JSON.stringify(body)
  const key = '62f41a4f880463cdc347556c15598999'
  return HmacMD5(body, key).toString(Hex)
}
